import src from "IMAGE";
export default { src, width: 466, height: 489, blurWidth: 0, blurHeight: 0};
